import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { motion } from 'motion/react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { X } from 'lucide-react';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const WeeklyGoalModal: React.FC<Props> = ({ visible, setVisible }) => {
  return (
    <Dialog
      className="tw-w-[600px] tw-rounded-lg tw-h-[600px]"
      visible={visible}
      onHide={() => setVisible(false)}
      closable={false}
      header={
        <div className="tw-flex tw-justify-self-end tw-items-center">
          <button
            aria-label="Close dialog"
            onClick={() => setVisible(false)}
            className="tw-bg-neutral-50 tw-border-none tw-rounded-full tw-px-2 tw-py-1"
          >
            <X size={16} />
          </button>
        </div>
      }
      footer={<Button type="button" label="Got it!" aria-label="Got it!" onClick={() => setVisible(false)} />}
      pt={{
        content: { className: 'tw-flex tw-justify-center' },
        footer: { className: '!tw-justify-center' },
        root: { className: '!tw-max-h-[85%]' },
      }}
    >
      <div className="tw-flex tw-flex-col tw-p-6">
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 1,
            delay: 0.5,
            ease: [0.34, 1.56, 0.64, 1],
          }}
        >
          <span className="tw-relative tw-left-[50px] tw-flex tw-justify-content tw-align-items tw-gap-x-2 tw-rotate-[-17.957deg] tw-px-[10px] tw-border tw-border-solid tw-rounded-md tw-self-start tw-leading-none tw-bg-neutral-950 tw-w-fit">
            <span className="tw-font-sora tw-text-base tw-font-bold tw-text-amber-300">NEW</span>
          </span>
          <p className="tw-text-center tw-font-bold tw-text-lg tw-leading-6 tw-text-gray-900 tw-font-sora tw-m-0">
            Track your
          </p>
          <h1 className="tw-text-center tw-font-bold tw-text-2xl tw-leading-8 tw-text-gray-900 tw-font-sora">
            Weekly Goal
          </h1>
          <p className="tw-text-center tw-text-gray-600 tw-leading-6 tw-text-base tw-font-atkinson tw-m-0">
            Pass 2 new skills each week
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 1.5, ease: [0.34, 1.56, 0.64, 1] }}
        >
          <DotLottieReact src={'/weekly-goal-header-1-2.json'} autoplay loop={true} />
        </motion.div>
        <motion.p
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 2, delay: 4, ease: [0.34, 1.56, 0.64, 1] }}
          className="tw-text-center tw-text-gray-600 tw-text-base tw-font-atkinson tw-m-0 tw-font-bold"
        >
          Get in the rhythm to make big progress
          <br /> on your Roadmap.
        </motion.p>
      </div>
    </Dialog>
  );
};

export default WeeklyGoalModal;
